import { PlaceholderPage } from './PlaceholderPage'

export default function Landing() {
  return <PlaceholderPage title="Landing" route="/" />
}
